import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';

export const HiddenAINode = Node.create({
  name: 'hiddenAINode',
  group: 'block',
  content: 'text*',
  atom: true,
  inline: false,
  selectable: false,
  draggable: false,

  parseHTML() {
    return [{ tag: 'hidden-ai-node' }];
  },
  renderText({ node }) {
    return node.textContent;
  },
  renderHTML({ HTMLAttributes }) {
    return ['hidden-ai-node', HTMLAttributes, 0];
  },
  addNodeView() {
    return ReactNodeViewRenderer(() => null);
  },
});
